import { Component, Input } from '@angular/core';
import { Process } from '../../process/process';


@Component({
  moduleId: module.id,
  selector: 'current-tasks',
  templateUrl: 'current-tasks.component.html',
  styleUrls: ['current-tasks.component.scss']
})
export class CurrentTasksComponent {
  @Input() processes: Array<Process> [];

  calcPercentage(current: number, total: number) {
      if (total > 0) {
        return Math.ceil((current / total) * 100).toString();
      } else {
        return '0';
      }
  }
}
